/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Validation optionnelle ou obligatoire pour tous les courtiers habilités au tunnel.
 * @export
 * @interface SetValidationOptionnellePourTousCommand
 */
export interface SetValidationOptionnellePourTousCommand {
    /**
     * 
     * @type {boolean}
     * @memberof SetValidationOptionnellePourTousCommand
     */
    validationOptionnelle: boolean;
}

/**
 * Check if a given object implements the SetValidationOptionnellePourTousCommand interface.
 */
export function instanceOfSetValidationOptionnellePourTousCommand(value: object): value is SetValidationOptionnellePourTousCommand {
    if (!('validationOptionnelle' in value) || value['validationOptionnelle'] === undefined) return false;
    return true;
}

export function SetValidationOptionnellePourTousCommandFromJSON(json: any): SetValidationOptionnellePourTousCommand {
    return SetValidationOptionnellePourTousCommandFromJSONTyped(json, false);
}

export function SetValidationOptionnellePourTousCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetValidationOptionnellePourTousCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'validationOptionnelle': json['validationOptionnelle'],
    };
}

export function SetValidationOptionnellePourTousCommandToJSON(json: any): SetValidationOptionnellePourTousCommand {
    return SetValidationOptionnellePourTousCommandToJSONTyped(json, false);
}

export function SetValidationOptionnellePourTousCommandToJSONTyped(value?: SetValidationOptionnellePourTousCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validationOptionnelle': value['validationOptionnelle'],
    };
}

